"use client";

import { c as _c } from "react/compiler-runtime";
import { CalendarRemove02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "@/components/ui/empty";
type TournamentListEmptyProps = {
  isFiltered: boolean;
};
export function TournamentListEmpty(t0) {
  const $ = _c(8);
  const {
    isFiltered
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <EmptyMedia variant="icon"><HugeiconsIcon icon={CalendarRemove02Icon} className="size-6" /></EmptyMedia>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isFiltered ? "No tournaments match filters" : "No tournaments yet";
  let t3;
  if ($[1] !== t2) {
    t3 = <EmptyTitle>{t2}</EmptyTitle>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isFiltered ? "Try adjusting or clearing the filters." : "Check back soon \u2014 tournaments are on the way.";
  let t5;
  if ($[3] !== t4) {
    t5 = <EmptyDescription>{t4}</EmptyDescription>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <Empty className="fade-in-50 animate-in bg-card"><EmptyHeader>{t1}{t3}{t5}</EmptyHeader></Empty>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}